// extracted by mini-css-extract-plugin
module.exports = {"auction":"auction-module--auction--2S1cD"};